module.exports = __webpack_public_path__ + "static/media/github icon.76d344f0.svg";